
import message from "./modules/views/message";
import patent from "./modules/views/patent";

const modules: { [key: string]: any } = {
  patent,
  message
};

export default modules;
